import { pageHead } from "@app/framework/meta";
import { AnalysisCoveragePage } from "@modules/investor-relations/pages";
import { trans } from "@mongez/localization";
import { MetaFunction } from "@remix-run/node";
import { useLoaderData } from "@remix-run/react";

export default function AnalysisCoverage() {
  useLoaderData();

  return <AnalysisCoveragePage />;
}

export const meta: MetaFunction = () =>
  pageHead({
    title: trans("analystCoverage"),
    appendAppName: true,
  });
